import { render } from "./PatientDetails.vue?vue&type=template&id=7d3e8412&scoped=true&ts=true"
import script from "./PatientDetails.vue?vue&type=script&lang=ts"
export * from "./PatientDetails.vue?vue&type=script&lang=ts"

import "./PatientDetails.vue?vue&type=style&index=0&id=7d3e8412&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3e8412"]])

export default __exports__